export default "__VITE_ASSET__86Z20Zqw__"